var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"city-avatar",attrs:{"adcode-prefix":_vm.adcode.toString().slice(0, 2)}},[_vm._v("\n  "+_vm._s(_vm.cityName)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }